import { VariantType } from '@sentecacommerce-theme/lib'

export const injectScript = (
  selectedVariant: VariantType | null | undefined
) => {
  if (document.getElementById('avent-script') || !selectedVariant) return

  const script = document.createElement('script')
  script.type = 'text/javascript'

  script.id = 'avent-script'
  script.src = '//media.flixfacts.com/js/loader.js'
  script.setAttribute('data-flix-distributor', '13704')
  script.setAttribute('data-flix-language', 'bg')
  script.setAttribute('data-flix-brand', 'PHILIPSAVENT')
  script.setAttribute('data-flix-mpn', '')
  script.setAttribute('data-flix-ean', selectedVariant?.masterBarcode ?? '')
  script.setAttribute('data-flix-sku', selectedVariant?.sku ?? '')
  script.setAttribute('data-flix-button', 'flix-minisite')
  script.setAttribute('data-flix-inpage', 'flix-inpage')
  script.setAttribute('data-flix-button-image', '')
  script.setAttribute('data-flix-price', '')
  script['async'] = true

  const element = document.getElementById('flix-inpage')
  element?.appendChild(script)
}
